export class EligibilityService {
  constructor(store, eligibilityClient) {
    this.store = store;
    this.eligibilityClient = eligibilityClient;
  }

  async getEligibilityForLabels(evaluationId) {
    try {
      const { data: eligibility } = await this.eligibilityClient.getEligibilitiesByAutomaticEvaluationId(evaluationId);
      const [{ policyCheckResultsOriginal: eligibilityData, eligibility: eligibilityType }] = eligibility;
      this.setEligibility(eligibilityData, eligibilityType);
    } catch (error) {
      throw new Error(`No se ha podido obtener la información de elegibilidad ${error.message}`);
    }
  }

  async getEligibilityPolicyAndContext(evaluationId) {
    try {
      const { data: eligibility } = await this.eligibilityClient.getEligibilitiesByAutomaticEvaluationId(evaluationId);
      const [{ policyCheckResultsOriginal, context }] = eligibility;
      return { policyCheckResultsOriginal, context };
    } catch (error) {
      throw new Error(`No se ha podido obtener la información de elegibilidad ${error.message}`);
    }
  }

  setEligibility(data, status, params) {
    this.store.commit('evaluation/setEligibilityData', { eligibilityData: data, eligibilityType: status, eligibilityParams: params });
  }

  getEligibilityList(eligibilityData) {
    if (!eligibilityData) {
      throw new Error('No se ha podido obtener la información de elegibilidad');
    }

    const data = Object.keys(eligibilityData)
      .map(key => this.transformPolicyToRequirement(eligibilityData[key], key));
    data.sort((a, b) => a.ruleName.localeCompare(b.ruleName));
    return data;
  }

  transformPolicyToRequirement(policyResult) {
    return {
      id: policyResult.policyCheckResultsId,
      label: policyResult.description,
      value: policyResult.result,
      comment: policyResult.comment,
      showComment: false,
      eligibility: policyResult.status,
      ruleName: policyResult.ruleName
    };
  }
}
